
import axios from 'axios';

export const api = axios.create({
    baseURL: 'https://apiom.overall.cloud:3333'
});

export default api;
